import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Textarea } from '@/components/ui/textarea';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Flag, AlertTriangle } from 'lucide-react';

/**
 * Report Dialog Component
 * Allows users to report unclaimed boxes for removal
 */
const ReportDialog = ({
  open,
  onOpenChange,
  reportingBox,
  reportReason,
  setReportReason,
  reportEmail,
  setReportEmail,
  isSubmitting,
  onSubmit
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="report-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Flag className="w-5 h-5 text-red-500" />
            Report Stall
          </DialogTitle>
          <DialogDescription>
            Let us know why this stall should be removed from the map.
          </DialogDescription>
        </DialogHeader>
        
        {reportingBox && (
          <div className="bg-gray-50 rounded-lg p-3 mb-4">
            <p className="font-medium text-gray-800">{reportingBox.name}</p>
            <p className="text-sm text-gray-500">{reportingBox.address}</p>
          </div>
        )}
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="reportReason">Reason for reporting *</Label>
            <Textarea
              id="reportReason"
              value={reportReason}
              onChange={(e) => setReportReason(e.target.value)}
              placeholder="e.g., This stall no longer exists, wrong location, etc."
              rows={3}
              data-testid="report-reason-input"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="reportEmail">Your email (optional)</Label>
            <Input
              id="reportEmail"
              type="email"
              value={reportEmail}
              onChange={(e) => setReportEmail(e.target.value)}
              placeholder="For follow-up if needed"
              data-testid="report-email-input"
            />
          </div>
          
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-start gap-2">
            <AlertTriangle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
            <p className="text-xs text-amber-800">
              Reports are reviewed by our team. Please only report stalls that genuinely need attention.
            </p>
          </div>
        </div>
        
        <DialogFooter className="mt-4">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            data-testid="report-cancel-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            disabled={isSubmitting || !reportReason.trim()}
            className="bg-red-600 hover:bg-red-700"
            data-testid="report-submit-btn"
          >
            {isSubmitting ? 'Submitting...' : 'Submit Report'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReportDialog;
